import { Box, useColorModeValue } from '@chakra-ui/react';
import { useAppSelector } from '../../../core/hooks/storeHooks';
import { calculateSectionHeightHelper } from '../../utils';
import MenuBar from './menuBar/MenuBar';
import CompactToolBar from './toolBar/CompactToolBar';
import CompactMenuBar from './menuBar/CompactMenuBar';

const TopSection = () => {
  const topSection = useAppSelector((state) => state.sections.topSection);
  const backgroundColor = useColorModeValue(
    'rgba(255, 255, 255, 0.5)',
    'rgba(22, 23, 24, 0.5)'
  );

  const totalHeight = calculateSectionHeightHelper(topSection);

  const { menuBar, toolBar } = topSection;

  return (
    <Box
      height={totalHeight + 'px'}
      width="100%"
      boxShadow="md"
      background={backgroundColor}
      // borderRadius="10px"
      rounded="2xl"
      // backdropFilter="blur(10px)"
    >
      {menuBar.isVisible && <MenuBar height={menuBar.height} />}
      <CompactToolBar height={toolBar.height} />
      {/* {menuBar.isVisible && <CompactMenuBar height={menuBar.height} />} */}
      {/* {toolBar.isVisible && <CompactToolBar height={toolBar.height} />} */}
    </Box>
  );
};

export default TopSection;
